import React, {useEffect, useRef, useState} from 'react';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const AdvancedMediaViewerPinchToZoom = ({children, scaleRatio, onZoom = ()=>{}}) => {
    const [zooming, setZooming] = useState(false);
    const transformRef = useRef(null);
    useEffect(() => {
        if (transformRef.current && scaleRatio) {
            transformRef.current.centerView(scaleRatio, 0, 'linear');
        }
    }
    , [scaleRatio]);
    
    return (
        <TransformWrapper
            initialScale={scaleRatio || 1}
            wheel={{
                step: 50,
            }}
            ref={transformRef}
            centerOnInit={true}
            limitToBounds={true} 
            doubleClick={{
                mode: "zoomOut", animationTime: 1, animationType: "linear", step: 100
            }}
            panning={{ disabled: !zooming }}
            onTransformed={(e) => {
                const isZooming = (e.state.scale !== scaleRatio) && (e.state.scale !== 1);
                setZooming(isZooming);
                onZoom(isZooming);
            }}
            onZoomStart={(e) => {
                onZoom(true);
            }}
            >
                <TransformComponent contentStyle={{width:'100%', height:'100%'}} wrapperStyle={{width:'100%', height:'100%'}}>
                    {children}
                </TransformComponent>
            </TransformWrapper>
    );
};

export default AdvancedMediaViewerPinchToZoom;